/**
 * Redux reducer for Observer app
 * Manages state for AI threads, filters, pagination, and UI state
 */

import { ObserverState, OBSERVER_ACTION_TYPES } from './observerTypes';
import Action from '../../store/action';

// Initial state
const initialState: ObserverState = {
  threads: [],
  selectedThread: null,
  selectedMessages: [],
  filters: {
    userId: '',
    ticketId: '',
    isDeleted: null,
    startDate: null,
    endDate: null,
    minMessages: null,
    maxMessages: null,
  },
  sort: {
    by: 'created',
    order: 'DESC',
  },
  pagination: {
    page: 1,
    pageSize: 20,
    totalCount: 0,
  },
  stats: {
    totalThreads: 0,
    activeThreads: 0,
    deletedThreads: 0,
    todayMessages: 0,
  },
  loading: false,
  error: null,
  showFilters: false,
};

export const observerReducer = (
  state: ObserverState = initialState,
  action: Action
): ObserverState => {
  switch (action.type) {
    case OBSERVER_ACTION_TYPES.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case OBSERVER_ACTION_TYPES.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case OBSERVER_ACTION_TYPES.SET_THREADS:
      return {
        ...state,
        threads: action.payload,
        loading: false,
        error: null,
      };

    case OBSERVER_ACTION_TYPES.SET_SELECTED_THREAD:
      return {
        ...state,
        selectedThread: action.payload,
      };

    case OBSERVER_ACTION_TYPES.SET_SELECTED_MESSAGES:
      return {
        ...state,
        selectedMessages: action.payload,
      };

    case OBSERVER_ACTION_TYPES.SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
        pagination: {
          ...state.pagination,
          page: 1, // Reset to first page when filters change
        },
      };

    case OBSERVER_ACTION_TYPES.SET_SORT:
      return {
        ...state,
        sort: action.payload,
        pagination: {
          ...state.pagination,
          page: 1, // Reset to first page when sort changes
        },
      };

    case OBSERVER_ACTION_TYPES.SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      };

    case OBSERVER_ACTION_TYPES.SET_STATS:
      return {
        ...state,
        stats: action.payload,
      };

    case OBSERVER_ACTION_TYPES.TOGGLE_FILTERS:
      return {
        ...state,
        showFilters: !state.showFilters,
      };

    case OBSERVER_ACTION_TYPES.RESET_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
        pagination: {
          ...state.pagination,
          page: 1,
        },
      };

    default:
      return state;
  }
};
